import { lazy, Suspense } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const LazyExpenseApprovalListView = lazy(() =>
  import('@webapp/modules/expense/feature-sets/ExpenseApprovalListView').then(
    ({ ExpenseApprovalListView }) => ({
      default: ExpenseApprovalListView,
    })
  )
)

export const ExpenseApprovalsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.approvalPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.approvalPageTitle),
        },
      ]}
    >
      <Suspense fallback={null}>
        <LazyExpenseApprovalListView />
      </Suspense>
    </Page>
  )
}
